import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const LockIcon = ({ width = 15, height = 19, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox='0 0 15 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.4169 18.5H1.69169C1.03626 18.5 0.5 17.9774 0.5 17.3387V8.04839H13.6086V17.3387C13.6086 17.9774 13.0724 18.5 12.4169 18.5Z'
        fill={hovered ? fill : 'none'}
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M5.86231 13.4121V15.0161C5.86231 15.6549 6.39845 16.1774 7.05373 16.1774C7.70902 16.1774 8.24516 15.6549 8.24516 15.0161V13.4121C8.61003 13.0928 8.84087 12.6282 8.84087 12.1129C8.84087 11.1476 8.0441 10.371 7.05373 10.371C6.06336 10.371 5.2666 11.1476 5.2666 12.1129C5.2666 12.6282 5.49744 13.0928 5.86231 13.4121Z'
        fill={hovered ? 'white' : 'none'}
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M2.58521 8.04839V4.85484C2.58521 2.45968 4.59619 0.5 7.05406 0.5C9.51193 0.5 11.5229 2.45968 11.5229 4.85484V8.04839'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
